import { render } from "./Transporters.vue?vue&type=template&id=7fd98b54"
import script from "./Transporters.vue?vue&type=script&lang=js"
export * from "./Transporters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__